import {folderDetails, listByUser, listDocument, agentsByBank, getAssignement} from "../../../api/entryPoint";
import api from "../../services/axiosHeader.js";

export const state = {
    folders: [],
    foldersByUser: [],
    details: {},
    agentsByBank: [],
    assignement: {},
    isLoading: true,
    isLoadingDetails: true
}

export const mutations = {
    SET_IS_LOADING(state, payload) {
        state.isLoading = payload
    },
    SET_IS_LOADING_DETAILS(state, payload) {
        state.isLoadingDetails = payload
    },
    SET_FOLDERS(state, newValue) {
        state.folders = newValue
    },
    SET_FOLDERS_BY_USER(state, newValue) {
        state.foldersByUser = newValue
    },
    SET_DETAILS(state, newValue) {
        state.details = newValue
    },
    SET_AGENTS_BY_BANK(state, newValue) {
        state.agentsByBank = newValue
    },
    SET_ASSIGNEMENT_BY_BANK(state, newValue) {
        state.assignement = newValue
    },
}

export const getters = {
    getIsLoading(state) {
        return state.isLoading;
    },
    getIsLoadingDetails(state) {
        return state.isLoadingDetails;
    },
    getList(state) {
        return state.folders;
    },
    getListByUser(state) {
        return state.foldersByUser;
    },
    getDetails(state) {
        return state.details;
    },
    getAgentsByBank(state) {
        return state.agentsByBank;
    },
    getAssignementByBank(state) {
        return state.assignement;
    }
}

export const actions = {
    // List all catalogs
    list({commit, state}, payload) {
        commit('SET_IS_LOADING', true);
        api.get(listDocument + payload.page  + gestionUrl(payload.filterCatalogs),
        ).then((res) => {
            commit('SET_FOLDERS', res.data);
            commit('SET_IS_LOADING', false);
        }).catch((error) => {
            console.log('here :'+error);
        });
    },

    // details of folder by id
    folderDetails({commit, state}, payload) {
        commit('SET_IS_LOADING_DETAILS', true);
        api.get(folderDetails + payload)
            .then((res) => {
                commit('SET_DETAILS', res.data[0]);
                commit('SET_IS_LOADING_DETAILS', false);
            })
            .catch((error) => {
                console.log(error);
            });
    },

    // List all folders by Current User
    listByUser({commit, rootState}) {
        api.get(listByUser + rootState.auth.userId)
            .then((res) => {
                commit('SET_FOLDERS_BY_USER', res.data);
            })
            .catch((error) => {
                console.log(error);
            });
    },
     
    //liste des agents par banque pour l'affectation du dossier 
    agentsByBank({commit}) {
        api.get(agentsByBank )
            .then((res) => {
                commit('SET_AGENTS_BY_BANK', res.data);
            })
            .catch((error) => {
                console.log(error);
            });
    },
    assignement({commit, state}, payload) {
        commit('SET_IS_LOADING_DETAILS', true);
        api.get(getAssignement + payload)
            .then((res) => {
                commit('SET_ASSIGNEMENT_BY_BANK', res.data[0]);
                commit('SET_IS_LOADING_DETAILS', false);
            })
            .catch((error) => {
                console.log(error);
            });
    },
}

export function gestionUrl(filter) {
    let url = "";
    for (let item in filter) {
        if ("s_duree_credit_souhait" === item) {
            url = url + "&" + item + filter[item];
        } else {
            url = url + "&" + item + "=" + filter[item];
        }
    }
    return url;
}